<template>
  <div class="w-full max-w-[1013px]">
    <div
      class="mb-5 font-roboto text-[26px] font-semibold leading-8 tracking-wider"
    >
      Выбор читателей
    </div>
    <div class="grid w-full gap-5 2xl:grid-cols-3">
      <WikiCard
        v-for="wiki in wikisData"
        :key="wiki.id"
        :data="wiki"
        disable-label
      />
    </div>
  </div>
</template>

<script setup>
const { wikis } = useWikis({
  per_page: 12,
  filters: { sort: 'select_reader' },
});

const wikisData = computed(() => wikis.data.value?.data || []);
</script>
